const { LOG_INVENTORY_REQUEST, LOG_INVENTORY_SUCCESS, LOG_INVENTORY_FAILED, LOG_HISTORY_INVENTORY_REQUEST, LOG_HISTORY_INVENTORY_SUCCESS, LOG_HISTORY_INVENTORY_FAILED } = require("app/redux/actions/Inventory/LogInventory/constant");

const LOG_INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const logInventoryReducer = function (state = LOG_INIT_STATE, action) {
    switch (action?.type) {
        case LOG_INVENTORY_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case LOG_INVENTORY_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case LOG_INVENTORY_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};

const LOG_HISTORY_INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const logHistoryInventoryReducer = function (state = LOG_HISTORY_INIT_STATE, action) {
    switch (action?.type) {
        case LOG_HISTORY_INVENTORY_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case LOG_HISTORY_INVENTORY_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case LOG_HISTORY_INVENTORY_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};